// @flow

import React from 'react';
import { Link } from 'react-router-dom';

import Page from '../components/Page';
import Section from '../components/Section';

type Props = {
  to?: string,
  toContext?: string
}

export default ({ to = '/', toContext = 'the home page' }: Props) => (
  <Page title="Page not found">
    <Section>
      <h3>Page not found</h3>
      <p>
        Couldn't find what you were looking for. <Link to={to}>Click here</Link> to return {toContext}.
      </p>
    </Section>
  </Page>
);



// WEBPACK FOOTER //
// ./src/views/NotFound.js